module.exports = __webpack_public_path__ + "static/media/8.72f48d16.jpg";